import { render, staticRenderFns } from "./PhotoArchiveModal.vue?vue&type=template&id=900971ea&"
import script from "./PhotoArchiveModal.vue?vue&type=script&lang=js&"
export * from "./PhotoArchiveModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports